import BlSectionHeaderMv from './BlSectionHeaderMv.vue'

BlSectionHeaderMv.install = function(Vue) {
  Vue.component(BlSectionHeaderMv.name, BlSectionHeaderMv)
}

export default BlSectionHeaderMv
